import styled from 'styled-components';
import getColour from '@lendi-ui/commons/colours';
import { link, LinkOptions } from '@lendi-ui/typography';

export const Link = styled.a<LinkOptions>`
  ${(props) => link({ size: props.size })};
  color: ${() => getColour('interaction', 'main')};
`;
